import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CancelIcon from '@material-ui/icons/Cancel';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import Typography from '../Typography';

const styles = (theme) => ({
  cancelIcon: {
    marginLeft: '5px',
    fontSize: '1em',
    color: theme.palette.facet.primaryGray,
  },
});

const DeleteButton = ({
  classes, className, onClick, ...rest
}) => {
  return (
    <Button1
      className={classNames(className, classes.root)}
      disableElevation
      onClick={onClick}
      {...rest}
      endIcon={<CancelIcon size="small" className={classes.cancelIcon} />}
    >
      <Typography variant="caption">Delete</Typography>
    </Button1>
  );
};

DeleteButton.defaultProps = {
  className: '',
};

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(DeleteButton);
